"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSvgIcon = void 0;
exports.MuiSvgIcon = {
    defaultProps: { fontSize: 'inherit', color: 'inherit' },
    styleOverrides: {
        root: {
            fontSize: 'inherit',
            color: 'inherit',
        },
    },
};
//# sourceMappingURL=MuiSvgIcon.js.map